/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateProjectPersonInput = {|
  projectId?: ?string,
  personId?: ?string,
  roleId?: ?string,
  projectGroupId?: ?string,
  personIds?: ?$ReadOnlyArray<?string>,
  contactIds?: ?$ReadOnlyArray<?string>,
  projectIds?: ?$ReadOnlyArray<?string>,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createProjectPersonMutationVariables = {|
  input: CreateProjectPersonInput
|};
export type createProjectPersonMutationResponse = {|
  +createProjectPerson: ?{|
    +errors: ?$ReadOnlyArray<?string>,
    +projectPersons: ?$ReadOnlyArray<?{|
      +id: string,
      +person: ?{|
        +id: string
      |},
      +project: ?{|
        +id: string
      |},
    |}>,
    +projectPersonsConnection: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +isContactPerson: ?boolean,
          +relationType: ?string,
          +role: ?{|
            +id: string,
            +name: ?string,
          |},
          +person: ?{|
            +id: string,
            +firstName: ?string,
            +lastName: ?string,
            +fullName: ?string,
            +initials: ?string,
            +profiles: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +name: ?string,
                |}
              |}>
            |},
            +permissions: ?$ReadOnlyArray<?string>,
            +email: ?string,
            +profilePictureId: ?string,
            +profilePictureDefaultId: ?number,
            +active: ?boolean,
            +isViewer: ?boolean,
            +harvestUser: ?boolean,
            +role: ?{|
              +id: string,
              +name: ?string,
            |},
            +personLabels: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +label: ?{|
                    +id: string,
                    +name: ?string,
                  |},
                |}
              |}>
            |},
          |},
          +project: ?{|
            +id: string
          |},
        |}
      |}>
    |},
    +projectPerson: ?{|
      +node: ?{|
        +id: string,
        +isContactPerson: ?boolean,
        +relationType: ?string,
        +role: ?{|
          +id: string,
          +name: ?string,
        |},
        +person: ?{|
          +id: string,
          +firstName: ?string,
          +lastName: ?string,
          +fullName: ?string,
          +initials: ?string,
          +profiles: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +name: ?string,
              |}
            |}>
          |},
          +permissions: ?$ReadOnlyArray<?string>,
          +email: ?string,
          +profilePictureId: ?string,
          +profilePictureDefaultId: ?number,
          +active: ?boolean,
          +isViewer: ?boolean,
          +harvestUser: ?boolean,
          +role: ?{|
            +id: string,
            +name: ?string,
          |},
          +personLabels: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +label: ?{|
                  +id: string,
                  +name: ?string,
                |},
              |}
            |}>
          |},
        |},
      |}
    |},
    +project: ?{|
      +id: string,
      +projectPersons: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +isContactPerson: ?boolean,
            +relationType: ?string,
            +role: ?{|
              +id: string,
              +name: ?string,
            |},
            +person: ?{|
              +id: string,
              +firstName: ?string,
              +lastName: ?string,
              +fullName: ?string,
              +initials: ?string,
              +profiles: ?{|
                +edges: ?$ReadOnlyArray<?{|
                  +node: ?{|
                    +id: string,
                    +name: ?string,
                  |}
                |}>
              |},
              +permissions: ?$ReadOnlyArray<?string>,
              +email: ?string,
              +profilePictureId: ?string,
              +profilePictureDefaultId: ?number,
              +active: ?boolean,
              +isViewer: ?boolean,
              +harvestUser: ?boolean,
              +role: ?{|
                +id: string,
                +name: ?string,
              |},
              +personLabels: ?{|
                +edges: ?$ReadOnlyArray<?{|
                  +node: ?{|
                    +id: string,
                    +label: ?{|
                      +id: string,
                      +name: ?string,
                    |},
                  |}
                |}>
              |},
            |},
          |}
        |}>
      |},
    |},
    +projectGroup: ?{|
      +id: string,
      +projects: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +projectPersons: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +isContactPerson: ?boolean,
                  +relationType: ?string,
                  +role: ?{|
                    +id: string,
                    +name: ?string,
                  |},
                  +person: ?{|
                    +id: string,
                    +firstName: ?string,
                    +lastName: ?string,
                    +fullName: ?string,
                    +initials: ?string,
                    +profiles: ?{|
                      +edges: ?$ReadOnlyArray<?{|
                        +node: ?{|
                          +id: string,
                          +name: ?string,
                        |}
                      |}>
                    |},
                    +permissions: ?$ReadOnlyArray<?string>,
                    +email: ?string,
                    +profilePictureId: ?string,
                    +profilePictureDefaultId: ?number,
                    +active: ?boolean,
                    +isViewer: ?boolean,
                    +harvestUser: ?boolean,
                    +role: ?{|
                      +id: string,
                      +name: ?string,
                    |},
                    +personLabels: ?{|
                      +edges: ?$ReadOnlyArray<?{|
                        +node: ?{|
                          +id: string,
                          +label: ?{|
                            +id: string,
                            +name: ?string,
                          |},
                        |}
                      |}>
                    |},
                  |},
                |}
              |}>
            |}
          |}
        |}>
      |},
    |},
  |}
|};
export type createProjectPersonMutation = {|
  variables: createProjectPersonMutationVariables,
  response: createProjectPersonMutationResponse,
|};
*/


/*
mutation createProjectPersonMutation(
  $input: CreateProjectPersonInput!
) {
  createProjectPerson(input: $input) {
    errors
    projectPersons {
      id
      person {
        id
      }
      project {
        id
      }
    }
    projectPersonsConnection {
      edges {
        node {
          id
          isContactPerson
          relationType
          role {
            id
            name
          }
          person {
            id
            firstName
            lastName
            fullName
            initials
            profiles(first: 10000) {
              edges {
                node {
                  id
                  name
                }
              }
            }
            permissions
            email
            profilePictureId
            profilePictureDefaultId
            active
            isViewer
            harvestUser
            role {
              id
              name
            }
            personLabels(first: 1000) {
              edges {
                node {
                  id
                  label {
                    id
                    name
                  }
                }
              }
            }
          }
          project {
            id
          }
        }
      }
    }
    projectPerson {
      node {
        id
        isContactPerson
        relationType
        role {
          id
          name
        }
        person {
          id
          firstName
          lastName
          fullName
          initials
          profiles(first: 10000) {
            edges {
              node {
                id
                name
              }
            }
          }
          permissions
          email
          profilePictureId
          profilePictureDefaultId
          active
          isViewer
          harvestUser
          role {
            id
            name
          }
          personLabels(first: 1000) {
            edges {
              node {
                id
                label {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
    project {
      id
      projectPersons(first: 1000000) {
        edges {
          node {
            id
            isContactPerson
            relationType
            role {
              id
              name
            }
            person {
              id
              firstName
              lastName
              fullName
              initials
              profiles(first: 10000) {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              permissions
              email
              profilePictureId
              profilePictureDefaultId
              active
              isViewer
              harvestUser
              role {
                id
                name
              }
              personLabels(first: 1000) {
                edges {
                  node {
                    id
                    label {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    projectGroup {
      id
      projects(first: 100000) {
        edges {
          node {
            projectPersons(first: 10000, excludeClientUsers: true) {
              edges {
                node {
                  id
                  isContactPerson
                  relationType
                  role {
                    id
                    name
                  }
                  person {
                    id
                    firstName
                    lastName
                    fullName
                    initials
                    profiles(first: 10000) {
                      edges {
                        node {
                          id
                          name
                        }
                      }
                    }
                    permissions
                    email
                    profilePictureId
                    profilePictureDefaultId
                    active
                    isViewer
                    harvestUser
                    role {
                      id
                      name
                    }
                    personLabels(first: 1000) {
                      edges {
                        node {
                          id
                          label {
                            id
                            name
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            id
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateProjectPersonInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectPerson",
  "kind": "LinkedField",
  "name": "projectPersons",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "person",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isContactPerson",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationType",
  "storageKey": null
},
v9 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 10000
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "initials",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v11/*: any*/)
      ],
      "concreteType": "ProfileTypeConnection",
      "kind": "LinkedField",
      "name": "profiles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Profile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v9/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "profiles(first:10000)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureDefaultId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isViewer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestUser",
      "storageKey": null
    },
    (v10/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "PersonLabelTypeConnection",
      "kind": "LinkedField",
      "name": "personLabels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PersonLabelTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Label",
                  "kind": "LinkedField",
                  "name": "label",
                  "plural": false,
                  "selections": (v9/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "personLabels(first:1000)"
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectPersonTypeConnection",
  "kind": "LinkedField",
  "name": "projectPersonsConnection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectPersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectPerson",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v10/*: any*/),
            (v12/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectPerson",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v12/*: any*/)
    ],
    "storageKey": null
  }
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectPersonTypeEdge",
  "kind": "LinkedField",
  "name": "projectPerson",
  "plural": false,
  "selections": (v14/*: any*/),
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectPersonTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v14/*: any*/),
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000000
        }
      ],
      "concreteType": "ProjectPersonTypeConnection",
      "kind": "LinkedField",
      "name": "projectPersons",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": "projectPersons(first:1000000)"
    }
  ],
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
],
v19 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "excludeClientUsers",
      "value": true
    },
    (v11/*: any*/)
  ],
  "concreteType": "ProjectPersonTypeConnection",
  "kind": "LinkedField",
  "name": "projectPersons",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": "projectPersons(excludeClientUsers:true,first:10000)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createProjectPersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectPersonPayload",
        "kind": "LinkedField",
        "name": "createProjectPerson",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v6/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": (v18/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projects(first:100000)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createProjectPersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectPersonPayload",
        "kind": "LinkedField",
        "name": "createProjectPerson",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v6/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectGroupType",
            "kind": "LinkedField",
            "name": "projectGroup",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": (v18/*: any*/),
                "concreteType": "ProjectTypeConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projects(first:100000)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createProjectPersonMutation",
    "operationKind": "mutation",
    "text": "mutation createProjectPersonMutation(\n  $input: CreateProjectPersonInput!\n) {\n  createProjectPerson(input: $input) {\n    errors\n    projectPersons {\n      id\n      person {\n        id\n      }\n      project {\n        id\n      }\n    }\n    projectPersonsConnection {\n      edges {\n        node {\n          id\n          isContactPerson\n          relationType\n          role {\n            id\n            name\n          }\n          person {\n            id\n            firstName\n            lastName\n            fullName\n            initials\n            profiles(first: 10000) {\n              edges {\n                node {\n                  id\n                  name\n                }\n              }\n            }\n            permissions\n            email\n            profilePictureId\n            profilePictureDefaultId\n            active\n            isViewer\n            harvestUser\n            role {\n              id\n              name\n            }\n            personLabels(first: 1000) {\n              edges {\n                node {\n                  id\n                  label {\n                    id\n                    name\n                  }\n                }\n              }\n            }\n          }\n          project {\n            id\n          }\n        }\n      }\n    }\n    projectPerson {\n      node {\n        id\n        isContactPerson\n        relationType\n        role {\n          id\n          name\n        }\n        person {\n          id\n          firstName\n          lastName\n          fullName\n          initials\n          profiles(first: 10000) {\n            edges {\n              node {\n                id\n                name\n              }\n            }\n          }\n          permissions\n          email\n          profilePictureId\n          profilePictureDefaultId\n          active\n          isViewer\n          harvestUser\n          role {\n            id\n            name\n          }\n          personLabels(first: 1000) {\n            edges {\n              node {\n                id\n                label {\n                  id\n                  name\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    project {\n      id\n      projectPersons(first: 1000000) {\n        edges {\n          node {\n            id\n            isContactPerson\n            relationType\n            role {\n              id\n              name\n            }\n            person {\n              id\n              firstName\n              lastName\n              fullName\n              initials\n              profiles(first: 10000) {\n                edges {\n                  node {\n                    id\n                    name\n                  }\n                }\n              }\n              permissions\n              email\n              profilePictureId\n              profilePictureDefaultId\n              active\n              isViewer\n              harvestUser\n              role {\n                id\n                name\n              }\n              personLabels(first: 1000) {\n                edges {\n                  node {\n                    id\n                    label {\n                      id\n                      name\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    projectGroup {\n      id\n      projects(first: 100000) {\n        edges {\n          node {\n            projectPersons(first: 10000, excludeClientUsers: true) {\n              edges {\n                node {\n                  id\n                  isContactPerson\n                  relationType\n                  role {\n                    id\n                    name\n                  }\n                  person {\n                    id\n                    firstName\n                    lastName\n                    fullName\n                    initials\n                    profiles(first: 10000) {\n                      edges {\n                        node {\n                          id\n                          name\n                        }\n                      }\n                    }\n                    permissions\n                    email\n                    profilePictureId\n                    profilePictureDefaultId\n                    active\n                    isViewer\n                    harvestUser\n                    role {\n                      id\n                      name\n                    }\n                    personLabels(first: 1000) {\n                      edges {\n                        node {\n                          id\n                          label {\n                            id\n                            name\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8f57a29b9a6e59a218ac2df85382077f';

module.exports = node;
